import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {AdditionalAreaType} from "../../../property/utils/get_additional_area_type";

export const hasPropertyTerrace = (property?: IPropertyDetail) =>
    !!property?.additional_areas[0] && !!property.additional_areas.find((elem) => elem.type === AdditionalAreaType.TERRACE);
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {AdditionalAreaType} from "../../../property/utils/get_additional_area_type";

export const hasPropertyTerrace = (property?: IPropertyDetail) =>
    !!property?.additional_areas[0] && !!property.additional_areas.find((elem) => elem.type === AdditionalAreaType.TERRACE);
